import React from 'react';
import { Form } from 'react-final-form';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import { MANUFACTURER } from 'constants/UserConstants';
import useExecuteAtMostMs from 'hooks/useExecuteAtMostMs';
import { closeReportIssueModal, createReportIssue } from 'modules/reportIssues/actions';
import { isCreateTicketLoading, getReportIssueInitialValues } from 'modules/reportIssues/selectors';
import { getCurrentUserRoles } from 'modules/users/selectors/currentUser';
import { ReportIssueForm } from 'ui/layout/ReportIssue/components/ReportIssueForm';
import { reportIssueSideEffectDecorator } from 'ui/layout/ReportIssue/decorators/reportIssueSideEffectDecorator';
import { validate as validateFn } from 'validations/reportIssue';

export const ReportIssue = () => {
  const dispatch = useDispatch();
  const intl = useIntl();

  const currentUserRoles = useSelector(getCurrentUserRoles);
  const loading = useSelector(isCreateTicketLoading);
  const initialValues = useSelector(getReportIssueInitialValues);
  const validate = useExecuteAtMostMs(values => validateFn(values, { intl, root: values, isManufacturer: currentUserRoles.includes(MANUFACTURER) }), 100);

  const handleModalCancel = React.useCallback(() => {
    dispatch(closeReportIssueModal());
  }, [dispatch]);

  const onSubmit = React.useCallback((values) => {
    dispatch(createReportIssue(values));
  }, [dispatch]);

  return (
    <Form
      validate={validate}
      onSubmit={onSubmit}
      component={ReportIssueForm}
      initialValues={initialValues}
      confirmLoading={loading}
      decorators={[reportIssueSideEffectDecorator]}
      onCancel={handleModalCancel}
    />
  );
};
